import React from "react";

export default (props) => (
    <form role="form" onSubmit={props.event}>
        {props.children}
    </form>
);
